import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function LiveFill(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.143 2.959a.508.508 0 01-.293.65A8.993 8.993 0 005.7 5.642 9.137 9.137 0 003 12.147c0 3.909 2.432 7.244 5.85 8.537.259.098.39.39.293.651a.498.498 0 01-.643.297C4.704 20.196 2 16.492 2 12.147c0-2.832 1.15-5.393 3-7.23a9.991 9.991 0 013.5-2.255.498.498 0 01.643.297zM14.857 2.959a.498.498 0 01.643-.297c3.796 1.435 6.5 5.14 6.5 9.485s-2.704 8.05-6.5 9.485a.498.498 0 01-.643-.297.508.508 0 01.293-.65C18.568 19.39 21 16.055 21 12.146c0-3.91-2.432-7.244-5.85-8.537a.508.508 0 01-.293-.651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.46 6.726a.498.498 0 01.65-.283c2.255.91 3.89 2.922 3.89 5.704 0 2.779-1.632 4.823-3.89 5.734a.498.498 0 01-.65-.283.508.508 0 01.28-.657c1.919-.775 3.26-2.473 3.26-4.794 0-2.318-1.338-3.988-3.26-4.763a.508.508 0 01-.28-.658zM10.539 6.725a.508.508 0 01-.277.658C8.355 8.158 7 9.765 7 12.147c0 2.321 1.341 4.02 3.26 4.794a.508.508 0 01.28.657.498.498 0 01-.65.283C7.632 16.97 6 14.926 6 12.147c0-2.858 1.664-4.798 3.889-5.703a.498.498 0 01.65.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.171c1.105 0 2-.906 2-2.024 0-1.118-.895-2.025-2-2.025s-2 .907-2 2.025c0 1.118.895 2.024 2 2.024z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(LiveFill);
export default ForwardRef;